const BASE_URL = "https://trekkin.pt";

export function normalizeTrekkinUrl(rawUrl) {
  if (!rawUrl) return null;
  const url = String(rawUrl).trim();
  if (!url) return null;

  if (url.startsWith("//")) {
    return `https:${url}`;
  }

  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url.replace(/^https?:\/\/www\.trekkin\.pt/i, BASE_URL);
  }

  if (url.startsWith("/")) {
    return `${BASE_URL}${url}`;
  }

  return `${BASE_URL}/${url}`;
}

export function buildGpxFetchUrl(rawUrl) {
  const normalized = normalizeTrekkinUrl(rawUrl);
  if (!normalized) return null;

  if (typeof window === "undefined") return normalized;
  const isNative =
    typeof window.Capacitor !== "undefined" &&
    typeof window.Capacitor.isNativePlatform === "function" &&
    window.Capacitor.isNativePlatform();
  if (isNative) return normalized;

  const origin = window.location?.origin || "";
  const isWebTrekkin =
    origin === "https://trekkin.pt" || origin === "https://www.trekkin.pt";
  let normalizedUrlObj = null;
  try {
    normalizedUrlObj = new URL(normalized);
  } catch {}
  const isAppUploadPath = !!normalizedUrlObj?.pathname?.match(
    /^\/(?:app\/)?app-upload\//
  );
  const isGpxUpload = /\/(?:app\/)?app-upload\/uploads\/gpx\//i.test(normalized);

  // Keep same-origin on web to avoid trekkin.pt <-> www.trekkin.pt CORS issues.
  if (isWebTrekkin && isAppUploadPath && normalizedUrlObj) {
    const query = normalizedUrlObj.search || "";
    const hash = normalizedUrlObj.hash || "";
    return `${normalizedUrlObj.pathname}${query}${hash}`;
  }

  if (isWebTrekkin && isGpxUpload) {
    return `/app/app-upload/proxy-gpx.php?url=${encodeURIComponent(normalized)}`;
  }

  return normalized;
}
